module.exports = __webpack_public_path__ + "img/startConfigurationColliers.81d884c.png";